import { ICardActionsColorTag } from '../../components/types';
import { IApplicationState, IColorTag, TBoardId, TCardId } from '../../../../../../../../types/types';
import { getCardColorTags } from '../../../../../../../../store/model/selectors/getCardColorTags';
import { IColor } from '../../../../../../../../types/model';
import { getBoardColors } from '../../../../../../../../store/model/board/selectors/getBoardColors';
import { createDeepEqualSelector } from '../../../../../../helpers/memoizeHelper';
import { getBoardCardColorTags } from '../../../../../../../../store/model/selectors/getBoardCardColorTags';

const CARD_ACTIONS_MAX_COLOR_TAGS = 4;

type TgetCardActionsColorTags = (
    state: IApplicationState,
    boardId: TBoardId,
    cardId: TCardId,
) => ICardActionsColorTag[];

const getCardColorTagsSelector = (
    boardColors: IColor[],
    boardCardColors: IColor[],
    cardColors: IColorTag[],
): IColor[] => {
    const colorTags: ICardActionsColorTag[] = [];
    colorTags.push(...cardColors.map(colorTag => { // сначала добавляем цвета карты
        return {
            ...colorTag,
            selected: true,
        }
    }));
    if (colorTags.length < CARD_ACTIONS_MAX_COLOR_TAGS) { // если мало, добавляем цвета используемые на других картах
        const boardCardsColorTags = boardCardColors
            .filter(colorTag => !colorTags.find(item => colorTag.id === item.id));
        colorTags.push(...boardCardsColorTags);
    }
    if (colorTags.length < CARD_ACTIONS_MAX_COLOR_TAGS) { // если мало, добавляем цвета доски
        const boardCardsColorTags = boardColors
            .filter(colorTag => !colorTags.find(item => colorTag.id === item.id));
        colorTags.push(...boardCardsColorTags);
    }

    return colorTags.slice(0, CARD_ACTIONS_MAX_COLOR_TAGS);
};

export const getCardActionsColorTagsCreateSelector = (
): TgetCardActionsColorTags => createDeepEqualSelector(
    (state: IApplicationState, boardId: TBoardId) => getBoardColors(state, boardId),
    (state: IApplicationState, boardId: TBoardId) => getBoardCardColorTags(state, boardId),
    (state: IApplicationState, boardId: TBoardId, cardId: TCardId) => getCardColorTags(state, cardId),
    getCardColorTagsSelector,
);
